
export default function ProductCategories() {
  const categories = [
    {
      icon: 'ri-restaurant-line',
      title: 'Jerky',
      description: 'Shelf-stable, high-margin, proven counter performance.',
    },
    {
      icon: 'ri-shopping-bag-line',
      title: 'Packaged Snacks',
      description: 'Impulse-ready items that move.',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Local Specialty Goods',
      description: 'Curated regional products.',
    }
  ];

  return (
    <section id="products" className="py-24 md:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Product Categories
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Carefully selected products that perform in independent retail environments
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden hover:shadow-lg transition-shadow cursor-pointer p-8"
            >
              <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center mb-4">
                <i className={`${category.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {category.title}
              </h3>
              <p className="text-base text-gray-700">
                {category.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
